export const CART_ITEM_STATUS = {
  IN_CART: "IN_CART",
  SAVED_FOR_LATER: "SAVED_FOR_LATER",
  CHECKED_OUT: "CHECKED_OUT",
  PAID: "PAID",
  IN_BANK_TRANSFER: "IN_BANK_TRANSFER",
  ARCHIVED: "ARCHIVED",
} as const;

export const SKIP_PAYMENT_ADD_TO_CART = "ADD_TO_CART";
export const SKIP_PAYMENT_INVOICE_LATER = "INVOICE_LATER";
export const SKIP_PAYMENT_ZERO_ENTRY = "ZERO_ENTRY";
